<section>
  <h4>{{ data.label }}</h4>
  <mat-checkbox
    *ngFor="let option of data.state.options"
    [checked]="option.selected"
    (change)="onDataChange($event.checked, option.value)"
    >{{ option.label }}</mat-checkbox
  >
</section>
